<label for="language-switcher" class="sr-only" i18n>Sprachauswahl</label>

<button
  [id]="buttonId"
  class="flex border border-transparent px-3 py-1.5 text-sm font-semibold tracking-wide text-gray-300 transition-colors hover:border-primary-green hover:text-white focus:border-primary-green focus:text-white"
  #selectTrigger
  type="button"
  (click)="switch()"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
>
  <pax-responsive-text variant="sm" [text]="label" [mobileText]="mobileLabel" />
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="-7 0 26 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="lucide lucide-chevron-down"
  >
    @if(isOpen) {
    <path d="m18 15-6-6-6 6" />
    } @else {
    <path d="m6 9 6 6 6-6" />
    }
  </svg>
</button>
<ng-template
  cdkTrapFocusAutoCapture
  cdkConnectedOverlay
  (overlayOutsideClick)="close()"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayPositions]="modalPositions"
>
  <pax-uncontrolled-select-list
    (tabOut)="close()"
    (clicked)="changedSelection.emit($event)"
    [id]="id+'-list'"
    [selectedValue]="selectedValue"
    [isOpen]="isOpen"
    [width]="buttonWidth"
    [options]="options"
  />
</ng-template>
